export const GIFT_PRODUCT = 'GiftProduct';
export const DEFAULT_TRACKING_PRICE = '0.00';
